var FIGURE = FIGURE || {};

FIGURE.init = function() {
	const cookieValue = $.cookie('homeAnimations');
	if (cookieValue === 'animated') {
		$('.starter-video').remove();
	} else {
		setTimeout(function(){
			$('.starter-video').fadeOut(900);
			$.cookie('homeAnimations', 'animated', { path: '/' });
		}, 9200);
	}	
}();

FIGURE.shippingMessage = function() {
	var specialMessageModal = $.cookie('specialmessage');
	if (specialMessageModal == 'read') {
		return;
	} else {
		setTimeout(function(){
			$('#figureMessageModal').modal();
		}, 3000);	
	}	
	$('#figureMessageModal').on('hide.bs.modal', function (event) {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
	$('#figureMessageModal a').click(function() {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
}();
